import React from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const AboutPage = () => {
  const { section } = useParams();

  const renderContent = () => {
    switch (section) {
      case "history":
        return (
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-xl shadow-lg p-8 leading-relaxed text-gray-700">
              <h2 className="text-3xl font-bold text-primary-500 mb-6 text-center relative pb-3 after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-20 after:h-1 after:rounded-full">
                ประวัติความเป็นมา
              </h2>
              <p className="mb-4">
                งานบริการวิชาการ สำนักส่งเสริมวิชาการและจัดการเรียนรู้ตลอดชีวิต
                มหาวิทยาลัยราชภัฏศรีสะเกษ
                เป็นหน่วยงานที่ดำเนินงานภายใต้สำนักส่งเสริมวิชาการและจัดการเรียนรู้ตลอดชีวิต
                ของมหาวิทยาลัยราชภัฏศรีสะเกษ
                ซึ่งมีบทบาทในการขับเคลื่อนภารกิจด้านบริการวิชาการ
                การจัดการเรียนรู้ และการให้บริการทางวิชาการแก่สังคม
              </p>
              <p className="mb-4">
                สำนักฯ
                จัดตั้งขึ้นเพื่อทำหน้าที่เป็นหน่วยงานหลักในการสนับสนุนการบริการวิชาการ
                ทั้งภายในและภายนอกมหาวิทยาลัย มุ่งเน้นการถ่ายทอดองค์ความรู้
                การพัฒนาศักยภาพประชาชน และการส่งเสริมการเรียนรู้ในทุกช่วงวัย
                ให้สอดคล้องกับพันธกิจของมหาวิทยาลัยในการเป็นแหล่งองค์ความรู้เพื่อการพัฒนาท้องถิ่น
              </p>
              <p>
                ปัจจุบัน
                หน่วยงานได้ขยายบทบาทการดำเนินงานให้ครอบคลุมการสนับสนุนชุมชน
                สถาบันท้องถิ่น องค์กรภาคประชาสังคม และหน่วยงานภายนอก
                พร้อมทั้งส่งเสริมแนวคิดการเรียนรู้ตลอดชีวิต (Lifelong Learning)
                ตามนโยบายการพัฒนาการศึกษาระดับอุดมศึกษาของประเทศไทย
              </p>
            </div>
          </div>
        );

      case "philosophy":
        return (
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-primary-500 mb-6 text-center relative pb-3 after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-20 after:h-1 after:rounded-full">
              ปรัชญา วิสัยทัศน์ พันธกิจ
            </h2>
            <div className="bg-gradient-to-br from-primary-50 to-blue-50 rounded-xl shadow-lg p-8">
              <div className="mb-8 p-6 bg-white rounded-lg border-l-4 border-secondary-500">
                <h3 className="text-xl font-semibold text-primary-500 mb-3 flex items-center">
                  <i className="fas fa-gem text-secondary-500 mr-2"></i>
                  ปรัชญา
                </h3>
                <p className="text-gray-700 text-lg italic">
                  "ระบบงานทันสมัย เต็มใจให้บริการ คุณภาพงานประทับใจ"
                </p>
              </div>

              <div className="mb-8 p-6 bg-white rounded-lg border-l-4 border-secondary-500">
                <h3 className="text-xl font-semibold text-primary-500 mb-3 flex items-center">
                  <i className="fas fa-eye text-secondary-500 mr-2"></i>
                  วิสัยทัศน์
                </h3>
                <p className="text-gray-700 text-lg italic">
                  "ส่งเสริมการจัดการศึกษาที่มีคุณภาพ
                  สร้างโอกาสการเรียนรู้ตลอดชีวิต ให้บริการด้วยความประทับใจ"
                </p>
              </div>

              <div className="p-6 bg-white rounded-lg border-l-4 border-secondary-500">
                <h3 className="text-xl font-semibold text-primary-500 mb-3 flex items-center">
                  <i className="fas fa-tasks text-secondary-500 mr-2"></i>
                  พันธกิจ
                </h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start gap-2">
                    <i className="fas fa-check-circle text-green-500 mt-1"></i>
                    <span>
                      ส่งเสริมการผลิตบัณฑิตและพัฒนากำลังคนที่มีสมรรถนะสอดคล้องกับบริบทพื้นที่
                      สามารถแข่งขันได้และเรียนรู้ตลอดชีวิต
                    </span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="fas fa-check-circle text-green-500 mt-1"></i>
                    <span>
                      ส่งเสริมการให้บริการวิชาการที่ตอบสนองความต้องการของชุมชนเพื่อสนับสนุนการพัฒนาท้องถิ่นอย่างยั่งยืน
                    </span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="fas fa-check-circle text-green-500 mt-1"></i>
                    <span>
                      บริหารจัดการและให้บริการด้วยระบบสารสนเทศที่ทันสมัย
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        );

      case "structure":
        return (
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-xl shadow-lg p-8 text-center">
              <h2 className="text-3xl font-bold text-primary-500 mb-6 text-center relative pb-3 after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-20 after:h-1 after:rounded-full">
                โครงสร้างการบริหาร
              </h2>
              <div className="relative group">
                <img
                  src="/assets/images/structure.png"
                  alt="โครงสร้างการบริหาร"
                  className="max-w-full h-auto mx-auto rounded-lg shadow-md transition-transform group-hover:scale-105"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      "https://via.placeholder.com/800x400?text=โครงสร้างการบริหาร";
                  }}
                />
              </div>
            </div>
          </div>
        );

      case "staff":
        return (
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-xl shadow-lg p-8 text-center">
              <h2 className="text-3xl font-bold text-primary-500 mb-6 text-center relative pb-3 after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-20 after:h-1 after:rounded-full">
                บุคลากร
              </h2>

              <div className="relative group">
                <img
                  src="/assets/images/structure-1.png"
                  alt="บุคลากร"
                  className="max-w-full h-auto mx-auto rounded-lg shadow-md transition-transform group-hover:scale-105"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      "https://via.placeholder.com/800x400?text=บุคลากร";
                  }}
                />
              </div>
            </div>
          </div>
        );

      case "law":
        return (
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-xl shadow-lg p-8">
              <h2 className="text-3xl font-bold text-primary-500 mb-6 text-center relative pb-3 after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-20 after:h-1 after:rounded-full">
                กฎหมาย / ระเบียบ
              </h2>
              <div className="space-y-4">
                <a
                  href="https://www.sskru.ac.th/wp-content/uploads/2023/02/%E0%B8%A3%E0%B8%B0%E0%B9%80%E0%B8%9A%E0%B8%B5%E0%B8%A2%E0%B8%9A%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%9A%E0%B8%A3%E0%B8%B4%E0%B8%AB%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%87%E0%B8%B4%E0%B8%99%E0%B8%A3%E0%B8%B2%E0%B8%A2%E0%B9%84%E0%B8%94%E0%B9%89%E0%B8%88%E0%B8%B2%E0%B8%81%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%83%E0%B8%AB%E0%B9%89%E0%B8%9A%E0%B8%A3%E0%B8%B4%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%97%E0%B8%B2%E0%B8%87%E0%B8%A7%E0%B8%B4%E0%B8%8A%E0%B8%B2%E0%B8%81%E0%B8%B2%E0%B8%A3114.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg hover:bg-primary-50 transition-colors group"
                >
                  <div className="w-10 h-10 bg-primary-100 rounded-full flex items-center justify-center text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                    <i className="fas fa-file-pdf"></i>
                  </div>
                  <div className="flex-1">
                    <h4 className="font-medium text-gray-800 group-hover:text-primary-500">
                      ระเบียบมหาวิทยาลัยราชภัฏศรีสะเกษ ว่าด้วย
                      การบริหารเงินรายได้จากการให้บริการทางวิชาการ พ.ศ. ๒๕๖๑
                    </h4>
                    <p className="text-sm text-gray-500 mt-1">
                      ขนาดไฟล์: 1.2 MB | ประเภท: PDF
                    </p>
                  </div>
                  <i className="fas fa-download text-gray-400 group-hover:text-primary-500"></i>
                </a>
              </div>
            </div>
          </div>
        );

      default:
        return (
          <div className="max-w-4xl mx-auto text-center">
            <div className="bg-gradient-to-br from-primary-50 to-blue-50 rounded-xl shadow-lg p-12">
              <p className="text-gray-600 text-lg">
                งานบริการวิชาการ สำนักส่งเสริมวิชาการและจัดการเรียนรู้ตลอดชีวิต
                มหาวิทยาลัยราชภัฏศรีสะเกษ
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
                <div className="p-4 bg-white rounded-lg">
                  <i className="fas fa-history text-2xl text-secondary-500 mb-2"></i>
                  <h3 className="font-semibold">ประวัติ</h3>
                </div>
                <div className="p-4 bg-white rounded-lg">
                  <i className="fas fa-gem text-2xl text-secondary-500 mb-2"></i>
                  <h3 className="font-semibold">ปรัชญา</h3>
                </div>
                <div className="p-4 bg-white rounded-lg">
                  <i className="fas fa-users text-2xl text-secondary-500 mb-2"></i>
                  <h3 className="font-semibold">บุคลากร</h3>
                </div>
              </div>
            </div>
          </div>
        );
    }
  };

  return (
    <>
      <Helmet>
        <title>
          เกี่ยวกับหน่วยงาน | งานบริการวิชาการ มหาวิทยาลัยราชภัฏศรีสะเกษ
        </title>
      </Helmet>

      <div className="min-h-screen bg-gradient-to-br from-primary-50 to-blue-50 py-12">
        <div className="container-custom">
          {/* Page Header */}
          <div className="text-center mb-12">
            <div className="inline-block p-4 bg-primary-100 rounded-full mb-4">
              <i className="fas fa-building text-3xl text-primary-500"></i>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-primary-500 mb-4 relative inline-block pb-4 after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-24 after:h-1 after:bg-secondary-500 after:rounded-full">
              เกี่ยวกับหน่วยงาน
            </h1>

            <p className="text-gray-600 max-w-2xl mx-auto">
              งานบริการวิชาการ สำนักส่งเสริมวิชาการและจัดการเรียนรู้ตลอดชีวิต
              มหาวิทยาลัยราชภัฏศรีสะเกษ
            </p>

            {/* Section Navigation */}
            <div className="flex flex-wrap justify-center gap-2 mt-8">
              <Link
                to="/about/history"
                className={`px-4 py-2 rounded-full transition-all ${
                  section === "history"
                    ? "bg-primary-500 text-white"
                    : "bg-gray-200 text-gray-700 hover:bg-primary-100"
                }`}
              >
                ประวัติ
              </Link>
              <Link
                to="/about/philosophy"
                className={`px-4 py-2 rounded-full transition-all ${
                  section === "philosophy"
                    ? "bg-primary-500 text-white"
                    : "bg-gray-200 text-gray-700 hover:bg-primary-100"
                }`}
              >
                ปรัชญา
              </Link>
              <Link
                to="/about/structure"
                className={`px-4 py-2 rounded-full transition-all ${
                  section === "structure"
                    ? "bg-primary-500 text-white"
                    : "bg-gray-200 text-gray-700 hover:bg-primary-100"
                }`}
              >
                โครงสร้าง
              </Link>
              <Link
                to="/about/staff"
                className={`px-4 py-2 rounded-full transition-all ${
                  section === "staff"
                    ? "bg-primary-500 text-white"
                    : "bg-gray-200 text-gray-700 hover:bg-primary-100"
                }`}
              >
                บุคลากร
              </Link>
              <Link
                to="/about/law"
                className={`px-4 py-2 rounded-full transition-all ${
                  section === "law"
                    ? "bg-primary-500 text-white"
                    : "bg-gray-200 text-gray-700 hover:bg-primary-100"
                }`}
              >
                กฎหมาย
              </Link>
            </div>
          </div>

          {/* Content - ใช้ Tailwind animation แทน */}
          <div className="animate-fade-in">{renderContent()}</div>
        </div>
      </div>
    </>
  );
};

export default AboutPage;
